// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"article_recommend":"c0c1ec","article_comment_list":"db9efc","article-insert":"9d5549","article_transfer":"044ff8","article_medal":"32c54d","dynamic4sentry":"40d654","benefits_chunk":"bed995","clipboard":"6bbfe5","webpack_container_remote_fed_sharedlib_startAria":"43f514"}[chunkId] + ".js";
};